import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Container from "./Container";
import LoginLogo from "./Logo";
import LoginRegBox from "./LoginRegBox";
import FormContainer from "./Form";
import RegBox from "./RegBox";
import { connect } from 'react-redux';
import { setPublicIP } from "../../../helpers/authHelper";
import Footer from "../../Footer";

class Login extends Component {
  constructor(props) {
    super(props);
    setPublicIP();
  }
  
  
 
  render() {
    return (
      <Container>
        <LoginLogo/>
        <LoginRegBox lang={this.props.currentlanguagelist}>
          <FormContainer/>
          <RegBox/>
        </LoginRegBox >
        
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentlanguagelist : state.currentlanguage.currentlanguage.languagelist
    
  }
}

export default connect(
  mapStateToProps
)(Login);

